module.exports = __webpack_public_path__ + "fwm_h5/img/xlanji.3fa2c819.png";